/* eslint-disable */

import React from 'react';
import i18next from 'i18next';
import Alert from './-RFC.ui-alert-logic';
import Cookie from 'common/services/util/-RFC.Cookie';

const DEFAULT_KEYS = {
    success: {
        title: 'cw.general.success',
        message: '',
    },
    error: {
        title: 'cw.general.ui.error',
        message: 'cw.modal.server-error.desc',
    },
    warning: {
        title: 'cw.general.warning',
        message: '',
    },
    info: {
        title: 'cw.general.information',
        message: '',
    },
};

const DEFAULT_DELAY = CWCONFIG.timeouts.notification || 4000;
let counter = 0;
const cookieConfig = CWCONFIG.cookie;
const { domain, rootDomain } = cookieConfig;

class AlertComponent extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            messages: {},
        };

        this.messageRef = {}

        this.onClose = this.onClose.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);

    }

    componentDidMount() {

        const messageObservable = Alert.getObservable();
        const onNextMessage = (data) => {

            // Rx fires first time empty
            if (Object.keys(data).length === 0 && data.constructor === Object) {

                return;

            }

            const currentMessages = this.state.messages;
            const processedMessage = this.buildAlertMessage(data);
            let uniqueId = counter;
            currentMessages[uniqueId] = processedMessage;
            counter++;


            this.setState({ messages: currentMessages }, () => {

                const timeoutId = setTimeout(() => {
                    this.onClose({
                        messageId: uniqueId,
                    })
                }, processedMessage.delay);

            });

        };
        messageObservable.subscribe(onNextMessage, () => { }, () => { });

    }

    onClose({ messageId }) {

        const currentMessages = this.state.messages;
        if (!currentMessages[messageId]) {

            return;

        }
        delete currentMessages[messageId];

        this.setState({
            messages: currentMessages,
        });

    }
    // Remove all token cookies set at login
    removeLoginCookies() {

        Cookie.remove(cookieConfig.token, {
            path: '/',
            domain,
        });

        Cookie.remove(cookieConfig.refreshToken, {
            path: '/',
            domain,
        });

        Cookie.remove(cookieConfig.token, {
            path: '/',
            domain: rootDomain,
        });

        Cookie.remove(cookieConfig.refreshToken, {
            path: '/',
            domain: rootDomain,
        });

    }

    handleStateChange(state, index) {

        // because ui-sref directives are not handled in the angular context
        // state change doesn't work
        // so we instead get a reference to the dom element
        // and look for a stateTo and stateParams attributes
        // to then navigate to a certain state
        const messageDOMref = this.messageRef[index];
        const hasStateTotransition = messageDOMref.querySelector('[stateTo]');
        const isModal = messageDOMref.querySelector('[modal]');
        if (hasStateTotransition) {
            const stateToTransition = hasStateTotransition.attributes.stateto.value;
            const stateParams = hasStateTotransition.attributes.stateparams && hasStateTotransition.attributes.stateparams.value;
            const paramsValues = stateParams ? stateParams.split(',') : [];
            const parsedStateParams = {};
            paramsValues.forEach((value) => {
                const param = value.split(':');
                if (param.length > 0) {
                    parsedStateParams[param[0]] = param[1];
                }
            })

            if (isModal) {

                if (this.props.$state.current.name.indexOf('.ltb') > -1) {

                    this.props.$state.go(`${this.props.$state.current.name}`, parsedStateParams);

                } else {

                    this.props.$state.go(`${this.props.$state.current.name}.ltb`, parsedStateParams);

                }

            } else {

                this.props.$state.go(stateToTransition, parsedStateParams);

            }

        }
        const clearAuthCookiesNeeded = messageDOMref.querySelector('[clearAuthCookies]');
        if (clearAuthCookiesNeeded) {
            this.removeLoginCookies();
        }
    }

    isObject(variable) {

        return variable !== null && typeof variable === 'object';

    }

    // construct the alert message structure
    buildAlertMessage(data) {
        const { args, params, type, timeout } = data;
        const response = {
            args: {},
            params: {},
            delay: timeout || DEFAULT_DELAY,
            type,
        };

        // check if it is not an object, put the args string in the message property
        if (!this.isObject(args)) {

            response.args = {
                message: args,
            };

            response.params = {
                title: {},
                message: params,
            };

        } else {

            response.args = args;
            response.params = (this.isObject(params)) ? params : { title: {}, message: {}, };

        }

        // set default values if missing
        response.args.title = (response.args.title) ? response.args.title : DEFAULT_KEYS[type].title;
        response.args.message = (response.args.message) ? response.args.message : DEFAULT_KEYS[type].message;
        response.args.icon = (response.args.icon) ? response.args.icon : {};

        // if alert is type error, we show addtional info about the server response data from http interceptors
        const errorMessage = this.props.$rootScope.errorMessage;

        if( type === 'error' && errorMessage) {

            const translatedErrorKey = i18next.t('cw.general.ui.error');
            response.args.serverResponse = translatedErrorKey + ' ' + errorMessage;

        }

        return this.translateMessage(response);

    }

    // translate the keys
    translateMessage(alertMessage) {

        alertMessage.args.title =
            i18next.t(alertMessage.args.title, alertMessage.params.title);
        alertMessage.args.message =
            i18next.t(alertMessage.args.message, alertMessage.params.message);

        return alertMessage;

    }

    render() {

        return (
            <div className="ui-alert-container">
                {
                    Object.keys(this.state.messages).reverse().map((messageKey, index) => {

                        const message = this.state.messages[messageKey];

                        return (
                            <div id="ui-alert" key={messageKey} className={`ui-alert ${message.type} ${message.args.icon.imageUrl && 'nobg'}`} connectqa-notif="body">
                                <div className="icon-holder">
                                    {
                                        message.args.icon.imageUrl
                                            ?
                                            <div className="img-holder"><img src={message.args.icon.imageUrl} /></div>
                                            :
                                            <div className={`icon icon-white ${message.args.icon.cssClasses || 'default-icon'} icon-s`} />
                                    }
                                </div>

                                <div className="message-holder">
                                    <h3 dangerouslySetInnerHTML={{ __html: message.args.title }} className="text-grey-1 text-l" connectqa-notif="title" />
                                    <h4 ref={(ref) => this.messageRef[index] = ref} onClick={(e) => this.handleStateChange(e, index)} dangerouslySetInnerHTML={{ __html: message.args.message }} className="text-grey-2 text-s" connectqa-notif="message" />
                                    <h5 dangerouslySetInnerHTML={{ __html: message.args.serverResponse }} className="text-grey-5 text-xs" />
                                </div>
                                <a onClick={() => this.onClose({ messageId: messageKey })} className="icon icon-close icon-grey-3 icon-xxs" connectqa-notif="close" />
                            </div>
                        );

                    })
                }
            </div>
        );
    }

}

export { AlertComponent };



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/ui-alert/react.ui-alert.js